var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocBackSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 177,
    viewBox: "0 0 280 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 16V161.167C280 165.366 278.45 169.394 275.691 172.363C272.932 175.332 269.189 177 265.287 177H14.713C10.8108 177 7.06845 175.332 4.3092 172.363C1.54996 169.394 -0.000183105 165.366 -0.000183105 161.167V16H280Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280 8.77512V16H-0.000183105V8.77512C-0.000183105 6.44781 1.54996 4.21583 4.3092 2.57017C7.06848 0.924519 10.8108 0 14.713 0H265.287C269.189 0 272.932 0.924519 275.691 2.57017C278.45 4.21583 280 6.44781 280 8.77512Z",
    fill: "#6B22B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4946 9.71742e-08H266.856C270.339 0.0024513 273.68 1.15286 276.144 3.19888C278.608 5.24491 279.995 8.0195 280 10.9141L279.949 13C279.949 6.97399 274.001 2.08015 266.69 2.08015H12.0762C9.15625 2.07856 6.31732 2.87779 3.99985 4.35382C5.22302 3.00158 6.80792 1.90427 8.62933 1.14864C10.4507 0.393016 12.4587 -0.000225689 14.4946 9.71742e-08Z",
    fill: "#C35CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102 127H250V133H102V127Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0001 39.0005H250V45.0005H82.0001V39.0005Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128 58H250V64H128V58Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0001 76.0005H250V82.0005H90.0001V76.0005Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6222 75.6416H81.0405V81.6416H17.6222V75.6416Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199 93.0005H250V99.0005H199V93.0005Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119 93.0005H185V99.0005H119V93.0005Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 93.0005H106V99.0005H17.9998V93.0005Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 144H106V150.001H17.9998V144Z",
    fill: "#CCCCCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113 144H201V150.001H113V144Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M207 144H250V150.001H207V144Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9999 127H87V133H43.9999V127Z",
    fill: "#CCCCCC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6225 58.4438H98.5181V64.4439H17.6225V58.4438Z",
    fill: "#CCCCCC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 110H250V116H17.9999V110Z",
    fill: "#CCCCCC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2769 38.9067H69.2632V44.9068H27.2769V38.9067Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocBackSide);
export default __webpack_public_path__ + "static/media/doc-back-side.11db77665db162edc39168e16b888992.svg";
export { ForwardRef as ReactComponent };